export default __webpack_public_path__ + "static/media/1.5a3a0b4c.svg";